import { useSelector } from "react-redux";
import clsx from "clsx";
import styles from "./index.module.scss";
import Input from "/components/common/input";
import { filterSliderProps } from "../../../../../../utils/constants";
import { Select } from "../../../../../common/select";

export default function Item({
  changedValues,
  filterCode,
  filterValues,
  onChange,
  onChangeSlider,
  onChangeSliderValue,
}) {
  const { filter, params } = useSelector((state) => state.filter);
  const { props } = useSelector((state) => state.props);

  return (
    <div
      key={`${filterCode}_${Object.values(filterValues).join("_")}`}
      className={styles.Item}
      data-test="filterItem"
      data-filter-code={filterCode}
    >
      <div className={styles.Name}>
        {filterCode === "price"
          ? "Цена, руб"
          : filter.filterNames[filterCode]?.replace("1", "")}
        {props[filterCode?.toUpperCase()]?.HINT && (
          <span className={clsx(styles.Hint)}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                fill="#9DA4AE"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.3322 9.01797C12.0417 8.96814 11.7428 9.02274 11.4887 9.17211C11.2345 9.32148 11.0414 9.55598 10.9436 9.83408C10.7603 10.3551 10.1894 10.6288 9.66843 10.4456C9.14744 10.2623 8.87367 9.69138 9.05694 9.17039C9.3115 8.44674 9.81396 7.83653 10.4753 7.44784C11.1367 7.05916 11.9143 6.91707 12.6703 7.04676C13.4264 7.17645 14.1122 7.56954 14.6062 8.15641C15.1001 8.74313 15.3705 9.48569 15.3695 10.2526C15.3691 11.5324 14.4224 12.3551 13.8001 12.77C13.4584 12.9978 13.1238 13.1643 12.8786 13.2733C12.7546 13.3284 12.6499 13.3704 12.5738 13.3994C12.5357 13.4139 12.5045 13.4252 12.4815 13.4334L12.453 13.4434L12.4436 13.4466L12.4401 13.4478L12.4386 13.4483C12.4383 13.4484 12.4374 13.4487 12.1212 12.5L12.4374 13.4487C11.9135 13.6233 11.3472 13.3402 11.1725 12.8162C10.998 12.2927 11.2806 11.7268 11.8038 11.5517C11.8037 11.5518 11.804 11.5516 11.8038 11.5517L11.8023 11.5522L11.8114 11.549C11.8213 11.5455 11.8384 11.5393 11.8618 11.5304C11.9087 11.5125 11.9796 11.4842 12.0664 11.4457C12.2427 11.3673 12.4702 11.2528 12.6907 11.1059C13.1923 10.7714 13.3695 10.4703 13.3695 10.2517L13.3695 10.2502C13.37 9.95539 13.266 9.66994 13.0762 9.44441C12.8863 9.21888 12.6228 9.06781 12.3322 9.01797ZM11.1502 15.5C11.1502 14.9477 11.5979 14.5 12.1502 14.5H12.1602C12.7125 14.5 13.1602 14.9477 13.1602 15.5C13.1602 16.0523 12.7125 16.5 12.1602 16.5H12.1502C11.5979 16.5 11.1502 16.0523 11.1502 15.5Z"
                fill="#9DA4AE"
              />
            </svg>
            <span className={styles.HintText}>
              {props[filterCode?.toUpperCase()]?.HINT}
            </span>
          </span>
        )}
        {params[filterCode]?.length > 0 && (
          <span className={styles.NameCnt}>
            {
              params[filterCode].filter(
                (code) => !["to", "from"].includes(code),
              ).length
            }
          </span>
        )}
      </div>

      <div className={clsx(styles.wrapperOpened, styles.wrapper)}>
        <div className={styles.inner}>
          {filterSliderProps.includes(filterCode) && (
            <span>
              <span className={styles.SliderVals}>
                <Input
                  classProp={styles.Input}
                  code="filterPriceMin"
                  placeholder={`от ${filterValues.min}`}
                  label={""}
                  value={changedValues[filterCode]?.min || ""}
                  onChange={(min) => onChangeSliderValue(filterCode, { min })}
                  onBlur={(min) =>
                    onChangeSlider(filterCode, {
                      min,
                      max: changedValues[filterCode]?.max,
                    })
                  }
                />
                <Input
                  classProp={styles.Input}
                  code="filterPriceMax"
                  placeholder={`до ${filterValues.max}`}
                  label={""}
                  value={changedValues[filterCode]?.max || ""}
                  onChange={(max) => onChangeSliderValue(filterCode, { max })}
                  onBlur={(max) =>
                    onChangeSlider(filterCode, {
                      max,
                      min: changedValues[filterCode]?.min,
                    })
                  }
                />
              </span>
            </span>
          )}

          {!filterSliderProps.includes(filterCode) && (
            <Select
              test="filterSelect"
              options={Object.entries(filterValues).map(
                ([valueCode, count]) => ({
                  value: valueCode,
                  name: filter.filterValueNames[valueCode] || valueCode,
                  count,
                }),
              )}
              placeholder={"Не выбрано"}
              selected={params[filterCode] || []}
              onChange={(value) => onChange(filterCode, value)}
            />
          )}
        </div>
      </div>
    </div>
  );
}
